// extracted by mini-css-extract-plugin
export default {"btn":"editmacro_btn__oHIWp","overflow-scroll":"editmacro_overflow-scroll__B8yel","deleteForm":"editmacro_deleteForm__WktZ2"};